// Mac refuses to parse PEM w/ different line endings.
export const formatPem = (pem: string) => pem.replace(/[\r\n]+/g, '\n')
